
import Vue from 'vue';
import dispositivos from '@/components/perfil/Dispositivos.vue';

export default Vue.extend({
  props: ['modal'],
  data() {
    return {
      datos: {
        nombreUsuario: '',
        dispositivo: [],
      },
    };
  },
  beforeMount() {
    this.cogerDatos();
  },
  methods: {
    cogerDatos() {
      this.$http
        .get(`Dispositivo/${this.modal.userId}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
        })
        .then((res) => {
          this.datos = res.data;
        });
    },
    activarDispositivo(identificacion: string) {
      this.$http
        .put(`/Dispositivo/admitir/${identificacion}`, '', {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
        })
        .then((res) => {
          this.cogerDatos();
        });
    },
    desactivarDispositivo(identificacion: string) {
      this.$http
        .put(`/Dispositivo/denegar/${identificacion}`, '', {
          headers: {
            Authorization: `Bearer ${this.$store.state.jwt}`,
          },
        })
        .then((res) => {
          this.cogerDatos();
        });
    },
  },
});
